module.exports=function(scope){ return `<div style="padding-bottom: 10px;">${scope.msg}</div>

${scope.pass}
${scope.otp}

<div id="${scope.errTxtId}" class="mdl-textfield asseco-mtoken-fMiddle">
    <span class="mdl-textfield__error"></span>
</div>`};